import $ from 'jquery';

$(document).ready(function() {
  const $pastShowhomesFilter = $('#past-showhomes-filter');
  const $showhomeCards = $('.showhome-card-wrapper');
  
  // Initial filtering - hide past showhomes by default
  filterShowhomes();
  
  // Add event listener to checkbox
  $pastShowhomesFilter.on('change', filterShowhomes);
  
  function filterShowhomes() {
    const includePastShowhomes = $pastShowhomesFilter.is(':checked');
    
    $showhomeCards.each(function() {
      const $this = $(this);
      const showhomeType = $this.data('showhome-type');
      
      if (showhomeType === 'past' && !includePastShowhomes) {
        // Hide past showhomes when checkbox is unchecked
        $this.addClass('hidden order-last');
      } else if (!$this.hasClass('price-filtered')) {
        // Only remove the hidden class if it's not already hidden by the price filter
        $this.removeClass('hidden order-last');
      }
    });
    
    // Update placeholder images visibility
    updatePlaceholderImages();
  }
  
  // Helper function to update placeholder images visibility
  function updatePlaceholderImages() {
    $('.js-builder').each(function() {
      const $builder = $(this);
      const visibleShowhomes = $builder.find('.js-showhomeCard:not(.hidden)').length;
      
      if (visibleShowhomes === 0) {
        $builder.find('.js-fullWidth').show();
      } else {
        $builder.find('.js-fullWidth').hide();
      }
    });
  }
});